var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('LoadingTips'):(_vm.error)?_c('div',[_vm._v(_vm._s(_vm.error))]):(_vm.corporation)?_c('CorporationDetail',{attrs:{"corporation":_vm.corporation}}):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }